import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import styled from 'styled-components';
import React__default from 'react';
import Text from '../text/text.component.js';
import Action from '../actions/action.component.js';
var _excluded = ["isMobile", "logo", "logoText", "title", "caption", "link", "linkText", "linkIcon", "LinkComponent", "img", "dark", "style"];
var Container = styled.div.withConfig({
  displayName: "big-cardcomponent__Container",
  componentId: "sc-vdrl8x-0"
})(["display:flex;flex-direction:column;max-width:562px;padding:56px;border-radius:34px;background:", ";box-sizing:border-box;"], function (props) {
  return props.dark ? "black" : "white";
});
styled.div.withConfig({
  displayName: "big-cardcomponent__Position",
  componentId: "sc-vdrl8x-1"
})(["height:100px;border-bottom:1px solid var(--light-gray-5);display:flex;align-items:center;"]);
var BigCard = function BigCard(_ref) {
  _ref.isMobile;
  var logo = _ref.logo,
    logoText = _ref.logoText,
    title = _ref.title,
    caption = _ref.caption,
    link = _ref.link,
    linkText = _ref.linkText,
    linkIcon = _ref.linkIcon,
    LinkComponent = _ref.LinkComponent,
    img = _ref.img,
    dark = _ref.dark,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Container, _extends({
    dark: dark,
    style: style
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      paddingBottom: "34px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Young",
    style: {
      height: "56px",
      width: "auto",
      objectFit: "contain"
    },
    src: logo
  }), /*#__PURE__*/React__default.createElement(Text, {
    fontFamily: "euclid",
    type: "label",
    fontSize: "xxlarge",
    color: dark ? "var(--white)" : null,
    style: {
      paddingLeft: "34px"
    }
  }, logoText)), /*#__PURE__*/React__default.createElement(Text, {
    fontFamily: "euclid",
    type: "display",
    tag: "h3",
    fontSize: "small",
    color: dark ? "var(--white)" : "var(--main)",
    style: {
      paddingBottom: "34px"
    }
  }, title), /*#__PURE__*/React__default.createElement(Text, {
    fontFamily: "euclid",
    type: "heading",
    fontSize: "mediumM",
    color: dark ? "var(--white)" : "var(--main)",
    style: {
      paddingBottom: "34px"
    }
  }, caption), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "auto",
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement(Action, {
    linkText: linkText,
    color: "green",
    active: true,
    linkIcon: linkIcon ? linkIcon : "arrow_right",
    link: link,
    LinkComponent: LinkComponent,
    forceHover: false,
    moveIcon: true,
    style: {
      paddingBottom: "48px"
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    alt: "young platform",
    style: {
      height: "240px",
      background: "var(--green)",
      borderRadius: "16px"
    },
    src: img
  })));
};
export { BigCard as default };